import { __rest, __assign } from '../../_virtual/_tslib.js';
import React from 'react';
import { StyledInput } from './style.js';

function BaseInput(_a) {
    var inputRef = _a.inputRef, isFocused = _a.isFocused, placeholder = _a.placeholder, value = _a.value, props = __rest(_a, ["inputRef", "isFocused", "placeholder", "value"]);
    return (React.createElement(StyledInput, __assign({ ref: inputRef, isFocused: isFocused, placeholder: isFocused && !value ? placeholder : undefined, value: value, onInvalid: function (e) {
            e.preventDefault();
        } }, props)));
}

export { BaseInput as default };
